import React from 'react'
import { ThemeProvider } from './context/ThemeContext'

export const WrapRootElement = ({ element }) => <ThemeProvider>{element}</ThemeProvider>
